/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ExpectedAnswerType } from './ExpectedAnswerType'
import {
  ExpectedAnswerTypeFromJSON,
  ExpectedAnswerTypeFromJSONTyped,
  ExpectedAnswerTypeToJSON,
} from './ExpectedAnswerType'
import type { GoOptionInternal } from './GoOptionInternal'
import {
  GoOptionInternalFromJSON,
  GoOptionInternalFromJSONTyped,
  GoOptionInternalToJSON,
} from './GoOptionInternal'
import type { GoQuestion } from './GoQuestion'
import {
  GoQuestionFromJSON,
  GoQuestionFromJSONTyped,
  GoQuestionToJSON,
} from './GoQuestion'
import type { GoStateLanguage } from './GoStateLanguage'
import {
  GoStateLanguageFromJSON,
  GoStateLanguageFromJSONTyped,
  GoStateLanguageToJSON,
} from './GoStateLanguage'
import type { GoStateMarket } from './GoStateMarket'
import {
  GoStateMarketFromJSON,
  GoStateMarketFromJSONTyped,
  GoStateMarketToJSON,
} from './GoStateMarket'

/**
 *
 * @export
 * @interface GowizardUndoV2Request
 */
export interface GowizardUndoV2Request {
  /**
   *
   * @type {boolean}
   * @memberof GowizardUndoV2Request
   */
  bevFiltersEnabled: boolean
  /**
   *
   * @type {string}
   * @memberof GowizardUndoV2Request
   */
  etelConfigId: string
  /**
   *
   * @type {Array<string>}
   * @memberof GowizardUndoV2Request
   */
  selections: Array<string>
  /**
   *
   * @type {GoStateLanguage}
   * @memberof GowizardUndoV2Request
   */
  language: GoStateLanguage
  /**
   *
   * @type {boolean}
   * @memberof GowizardUndoV2Request
   */
  textPreview: boolean
  /**
   *
   * @type {GoStateMarket}
   * @memberof GowizardUndoV2Request
   */
  market: GoStateMarket
  /**
   *
   * @type {ExpectedAnswerType}
   * @memberof GowizardUndoV2Request
   */
  answerType: ExpectedAnswerType
  /**
   *
   * @type {string}
   * @memberof GowizardUndoV2Request
   */
  desiredDealerDateOverride?: string | null
  /**
   *
   * @type {Array<GoOptionInternal>}
   * @memberof GowizardUndoV2Request
   */
  lastQuestionOptions?: Array<GoOptionInternal> | null
  /**
   *
   * @type {GoQuestion}
   * @memberof GowizardUndoV2Request
   */
  storedNextQuestion?: GoQuestion | null
  /**
   *
   * @type {Array<string>}
   * @memberof GowizardUndoV2Request
   */
  storedEtelItems?: Array<string> | null
}

/**
 * Check if a given object implements the GowizardUndoV2Request interface.
 */
export function instanceOfGowizardUndoV2Request(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'bevFiltersEnabled' in value
  isInstance = isInstance && 'etelConfigId' in value
  isInstance = isInstance && 'selections' in value
  isInstance = isInstance && 'language' in value
  isInstance = isInstance && 'textPreview' in value
  isInstance = isInstance && 'market' in value
  isInstance = isInstance && 'answerType' in value

  return isInstance
}

export function GowizardUndoV2RequestFromJSON(
  json: any,
): GowizardUndoV2Request {
  return GowizardUndoV2RequestFromJSONTyped(json, false)
}

export function GowizardUndoV2RequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GowizardUndoV2Request {
  if (json === undefined || json === null) {
    return json
  }
  return {
    bevFiltersEnabled: json['BevFiltersEnabled'],
    etelConfigId: json['EtelConfigId'],
    selections: json['Selections'],
    language: GoStateLanguageFromJSON(json['Language']),
    textPreview: json['TextPreview'],
    market: GoStateMarketFromJSON(json['Market']),
    answerType: ExpectedAnswerTypeFromJSON(json['AnswerType']),
    desiredDealerDateOverride: !exists(json, 'DesiredDealerDateOverride')
      ? undefined
      : json['DesiredDealerDateOverride'],
    lastQuestionOptions: !exists(json, 'LastQuestionOptions')
      ? undefined
      : json['LastQuestionOptions'] === null
      ? null
      : (json['LastQuestionOptions'] as Array<any>).map(
          GoOptionInternalFromJSON,
        ),
    storedNextQuestion: !exists(json, 'StoredNextQuestion')
      ? undefined
      : GoQuestionFromJSON(json['StoredNextQuestion']),
    storedEtelItems: !exists(json, 'StoredEtelItems')
      ? undefined
      : json['StoredEtelItems'],
  }
}

export function GowizardUndoV2RequestToJSON(
  value?: GowizardUndoV2Request | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    BevFiltersEnabled: value.bevFiltersEnabled,
    EtelConfigId: value.etelConfigId,
    Selections: value.selections,
    Language: GoStateLanguageToJSON(value.language),
    TextPreview: value.textPreview,
    Market: GoStateMarketToJSON(value.market),
    AnswerType: ExpectedAnswerTypeToJSON(value.answerType),
    DesiredDealerDateOverride: value.desiredDealerDateOverride,
    LastQuestionOptions:
      value.lastQuestionOptions === undefined
        ? undefined
        : value.lastQuestionOptions === null
        ? null
        : (value.lastQuestionOptions as Array<any>).map(GoOptionInternalToJSON),
    StoredNextQuestion: GoQuestionToJSON(value.storedNextQuestion),
    StoredEtelItems: value.storedEtelItems,
  }
}
